import { Directive, ElementRef, HostListener } from "@angular/core";

@Directive({
    selector: "[appDrivebKmMask]",
    standalone: false
})
export class KmMaskDirective {
  constructor(private el: ElementRef) {}

  @HostListener("input", ["$event"]) onInput(event: any) {
    const initialValue = this.el.nativeElement.value;
    const cleanedValue = initialValue.replace(/[^0-9]/g, "");
    const formattedValue = this.addThousandSeparator(cleanedValue);
    this.el.nativeElement.value = formattedValue;
  }
  private addThousandSeparator(value: string): string {
    if (!value) return value;
    const [integerPart, decimalPart] = value.split(".");
    const formattedIntegerPart = integerPart.replace(
      /\B(?=(\d{3})+(?!\d))/g,
      "."
    );
    if (decimalPart) {
      return `${formattedIntegerPart}.${decimalPart}`;
    } else {
      return formattedIntegerPart;
    }
  }
}
